import React from "react";

export default function SignUpMail() {
  return (
    <div
      className="signUpMail"
      style={{
        width: "800px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 auto",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          position: "relative"
        }}
      >
        <img
          src="https://pvx-images.s3.me-south-1.amazonaws.com/Email_Banner_1742452109688.png"
          alt="Email_banner"
          style={{ width: "100%" }}
        ></img>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          padding: "20px 10px",
        }}
      >
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Smith PVX Solar Design Tool – Get Started Today!
        </h1>
        <p
          style={{
            fontSize: "16px",
            lineHeight: 1.6,
            color: "#555",
          }}
        >
          <br />
          Hi [Name],
          <br />
          <br />
          We're excited to introduce you to the
          <strong> Smith PVX Solar Design Tool</strong>—a powerful platform
          designed to streamline the design and sale of C&I solar projects with
          unmatched speed and efficiency. Your access has been successfully
          created, unlocking seamless solar simulation and design capabilities
          to help you optimize your projects effortlessly.
          <br />
          <br />
          Below are your login credentials:
          <br />
          <strong>🔹 Email:</strong> [User Email]
          <br />
          <strong>🔹 Password:</strong> [User Password]
          <br />
          <br />
          To get started, click the link below and log in:
          <br />
          👉
          <a
            href="https://smithpvx.com/signin"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007BFF",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Access Smith PVX Solar Design Tool
          </a>
          <br />
          <br />
          Need help getting started? Check out our step-by-step tutorial:
          <br />
          📖
          <a
            href="https://www.youtube.com/watch?v=0omlpTY9SQM&t=2s"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#28A745",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Watch the PVX Tutorial
          </a>
          <br />
          <br />
          Your feedback is invaluable to us! If you have any questions or
          require assistance, please don’t hesitate to reach out.
          <br />
          <strong>Happy designing!</strong>
          <br />
          <br />
          Best regards,
          <br />
          <strong>The Smith PVX Team</strong>
        </p>
      </div>
      <div
        style={{
          width: "100%",
          position: "relative",
        }}
      >
        <img
          src="https://pvx-images.s3.me-south-1.amazonaws.com/Email_Footer_1742452135455.png"
          alt="Email_banner"
          style={{ width: "100%" }}
        ></img>
      </div>
    </div>
  );
}
